export const getAllVouchers = <T>(denominationsByCountry: Record<string, T[]>) =>
  Object.values(denominationsByCountry).reduce<T[]>((acc, cur) => [...acc, ...cur], [])
